import { render, staticRenderFns } from "./classStatistics.vue?vue&type=template&id=428096dc&scoped=true"
import script from "./classStatistics.vue?vue&type=script&lang=js"
export * from "./classStatistics.vue?vue&type=script&lang=js"
import style0 from "./classStatistics.vue?vue&type=style&index=0&id=428096dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428096dc",
  null
  
)

export default component.exports